import { Alphabets } from '@/components/header/constants'

interface ReturnType {
    alphabet: string | undefined
    index: number | undefined | string
}

export default function getBrandAlphabet(current: string, last: string | undefined | null): ReturnType {
    if (!last) {
        return { alphabet: '', index: '' }
    } else if (current.slice(0, 1) !== last.slice(0, 1)) {
        const alphabetIndex = Alphabets.indexOf(current.slice(0, 1))

        return { alphabet: Alphabets[alphabetIndex] === 'آ' ? 'ا' : Alphabets[alphabetIndex], index: alphabetIndex }
    } else {
        return { alphabet: undefined, index: undefined }
    }
}
